import { useEffect, useState } from "react";
import { GlobalTable } from "../../../global/components/GlobalTable";
import { useNavigate, useSearchParams } from "react-router-dom";
import useGet from "../../../global/hooks/useGet";
import { AccountColumns } from "./Columns";
import ConfirmModal from "../../../global/components/ConfirmModal";
import useDelete from "../../../global/hooks/useDelete";
import {
  openConfirmNotification,
  openErrorNotification,
} from "../../../global/utils/toast";
import { AccountFilter } from "../Components/FilterComponent";
import CommonBreadcrumb from "../../../global/components/CommonBreadcrumb";
import { Modal } from "antd";
import { SendInvitationForm } from "../Components/SendInvitationForm";
import { MailOutlined, SendOutlined } from "@ant-design/icons";
import OemIcon from "../../../assets/images/vectors/SideBarIcons/OemIcon";
import AccountIcon from "../../../assets/images/vectors/SideBarIcons/AccountIcon";
import DealerIcon from "../../../assets/images/vectors/SideBarIcons/DealerIcon";
import CommonButton from "../../../global/components/CommonButton";
import { VscServerProcess } from "react-icons/vsc";
import SentIcon from "../../../assets/images/vectors/SentIcon";

const initialFilterState = {
  UserId: "",
  AccountName: "",
  Email: "",
  AccountType: "",
  OemNo: "",
  DealerNo: "",
  CustomerNo: "",
  AccountTypeIds: undefined,
};

export const Account = () => {
  const [hoveredRow, setHoveredRow] = useState(null);
  const [listData, setListData] = useState([]);
  const [params, setParams] = useSearchParams({
    limit: 10,
    sort_by: "AccountNo",
    order: "desc",
  });
  const modParams = { ...Object.fromEntries([...params?.entries()]) } || {}; //
  const initialPagination = {
    current: parseInt(modParams.page) || 1,
    pageSize: parseInt(modParams.limit) || 10,
    total: 0,
  };
  const [pagination, setPagination] = useState(initialPagination);
  const [filter, setFilter] = useState(initialFilterState);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [filterNoValueText, setFilterNoValueText] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isOpenModal, setIsOpenModal] = useState(false);
  const [modalType, setModalType] = useState("");
  const logData = JSON.parse(sessionStorage.getItem("userData"));

  const navigate = useNavigate();

  const breadcrumbItems = [
    {
      label: "Account",
      href: "/account",
    },
  ];

  // to get table data from API server
  const query = new URLSearchParams(params);
  // Remove unwanted keys
  query.delete("pageSize");
  query.delete("total");
  query.delete("current");
  const updatedQuery = query.toString();

  const url = updatedQuery
    ? `${process.env.REACT_APP_API_URL}/api/accounts/?${updatedQuery}`
    : `${process.env.REACT_APP_API_URL}/api/accounts/`;
  const { data, loading, error, refetch } = useGet(url);

  useEffect(() => {
    const matchedFilter = {};
    for (const key in initialFilterState) {
      if (modParams[key] !== undefined) {
        matchedFilter[key] = modParams[key];
      }
    }

    setFilter((prev) => ({
      ...prev,
      ...matchedFilter,
    }));
  }, []);

  const deleteUrl = `${process.env.REACT_APP_API_URL}/api/accounts/bulk-delete/`;
  // selectedRowKeys?.length > 1
  //   ? (deleteUrl = `${process.env.REACT_APP_API_URL}/api/accounts/delete/`)
  //   : (deleteUrl = `${process.env.REACT_APP_API_URL}/api/accounts/delete/${selectedRowKeys}/`);

  const {
    data: deletedData,
    loading: deletedDataLoading,
    error: deletedDataError,
    // deleteData,
    deleteMultiple,
  } = useDelete(deleteUrl);

  const paginationConfig = {
    current: pagination.current, //current page
    pageSize: pagination.pageSize, // items per page
    total: data?.count, // total items
    showSizeChanger: true,
    pageSizeOptions: [10, 20, 50, 100],
    showTotal: (total, range) => `Total ${total} items ${range[0]}-${range[1]}`,
    onChange: (page, pageSize) => {
      setPagination({
        ...pagination,
        current: page,
        pageSize: pageSize,
      });

      const updatedParams = {
        ...Object.fromEntries([...params.entries()]),
        limit: pageSize,
        page: page,
      };
      setParams(updatedParams);
    },
  };

  const onSelectChange = (newSelectedRowKeys, newSelectedRow) => {
    setSelectedRowKeys(newSelectedRowKeys);
  };

  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
    fixed: true,
  };

  const onRow = (record) => {
    return {
      onClick: (event) => {
        navigate(`/account/info/${record?.AccountNo}`);
      },
    };
  };

  const handleFilterChange = (e) => {
    const inputName = e.target.name;
    const inputValue = e.target.value.replace(/['""`''""]/g, "");
    setFilter({ ...filter, [inputName]: inputValue });
  };

  const handleFilter = (customFilter) => {
    // Check if customFilter is an event object or actual filter
    const isEvent = customFilter?.nativeEvent || customFilter?._reactName;
    const filterToUse = isEvent ? filter : customFilter || filter;

    const filterDict = {};

    for (const key in filterToUse) {
      const value = filterToUse[key];
      if (
        value !== null &&
        value !== "" &&
        value !== undefined &&
        (typeof value === "string" ||
          typeof value === "number" ||
          typeof value === "boolean")
      ) {
        filterDict[key] = value;
      }
    }

    const isEmpty = Object.keys(filterDict).length === 0;

    if (isEmpty) {
      setFilterNoValueText("No value exists!");
      handleReset();
    } else {
      const params = {
        limit: 10,
        sort_by: "AccountNo",
        order: "desc",
        page: 1,
        ...filterDict,
      };
      setPagination((prev) => ({ ...prev, current: 1 }));
      setParams(params);
      refetch();
    }
  };
  //sent invitation
  const handleInvitation = (e) => {
    setIsModalOpen(true);
  };
  // reset
  const handleReset = (e) => {
    setFilter({
      current: 1,
      pageSize: 10,
      total: 0,
    }); //
    setPagination({
      current: 1,
      pageSize: 10,
      total: 0,
    }); //
    const params = {
      limit: 10,
      sort_by: "AccountNo",
      order: "desc",
    };
    setParams(params);
    refetch();
  };

  const onDeleteConfirm = async () => {
    try {
      // if (selectedRowKeys.length === 1) {
      //   await deleteData();
      // } else {
      await deleteMultiple({ ids: selectedRowKeys });
      // }
    } catch (error) {
      openErrorNotification("Something went wrong");
    }
    setShowModal(false);
    setSelectedRowKeys([]);
  };

  useEffect(() => {
    if (deletedData && !deletedDataError) {
      openConfirmNotification("Success");
      refetch();
    } else if (deletedDataError) {
      openErrorNotification(
        deletedDataError?.response?.data?.message || "Something went wrong",
      );
    }
  }, [deletedData, deletedDataError]);

  useEffect(() => {
    if (data && !loading) {
      const newData = data?.data?.map((el) => ({
        ...el,
        key: el?.AccountNo,
      }));
      setListData(newData);
    }
  }, [data, loading]);

  return (
    <div>
      <div className="pb-4 -mt-4 pt-[6px]">
        <CommonBreadcrumb breadcrumbItems={breadcrumbItems}>

          <CommonButton
            buttonsData={[
              {
                label: " Invitation",
                icon: (
                  <SentIcon className="!text-[14px] font-medium" />),
                onClick: () => {
                  navigate(`/invitation`);
                },
              },
            ]}
          />
        </CommonBreadcrumb>
      </div>
      <div className="p-4 bg-white rounded-[4px] border border-gray-200">
        <AccountFilter
          filter={filter}
          handleFilterChange={handleFilterChange}
          handleFilter={handleFilter}
          handleReset={handleReset}
          setShowModal={setShowModal}
          selectedRowKeys={selectedRowKeys}
          setFilter={setFilter}
          handleInvitation={handleInvitation}
        />
        <ConfirmModal
          showModal={showModal}
          setShowModal={setShowModal}
          onDeleteConfirm={onDeleteConfirm}
          setSelectedRowKeys={setSelectedRowKeys}
        />
        <Modal
          afterClose={() => setModalType("")}
          destroyOnClose={true}
          title={
            <div className="flex items-center bg-gray-200 p-2 rounded-md">
              {modalType === "OEM" ? (
                <OemIcon className="text-[15px] text-black ml-1" />
              ) : modalType === "Dealer" ? (
                <DealerIcon className="text-[15px] text-black ml-1" />
              ) : modalType === "Customer" ? (
                <AccountIcon className="text-[15px] text-black ml-1" />
              ) : (
                <SendOutlined className="text-[15px] text-black ml-1" />
              )}
              <span className="text-[14px] font-[Poppins] text-black  ml-2">
                {isOpenModal ? `Add ${modalType}` : "Send Invitation"}
              </span>
            </div>
          }
          open={isModalOpen}
          closable={false}
          onCancel={() => setIsModalOpen(false)}
          footer={null}
          width={580}
          centered
        >
          <SendInvitationForm
            setIsModalOpen={setIsModalOpen}
            isOpenModal={isOpenModal}
            setIsOpenModal={setIsOpenModal}
            setModalType={setModalType}
            modalType={modalType}
            isModalOpen={isModalOpen}
          />
        </Modal>
        <GlobalTable
          columns={AccountColumns(
            hoveredRow,
            setShowModal,
            setSelectedRowKeys,
            setParams,
            params,
          )}
          dataSource={listData.filter(
            (item) => item.UserId !== logData.user_id,
          )}
          rowSelection={rowSelection}
          pagination={paginationConfig}
          onRow={(record, rowIndex) => {
            return {
              onMouseEnter: () => setHoveredRow(rowIndex),
              onMouseLeave: () => setHoveredRow(null),
              ...onRow?.(record, rowIndex),
            };
          }}
          // resize
          loading={loading}
        />
      </div>
    </div>
  );
};
